import Model, { hasMany } from '@warp-drive/legacy/model';
import type CommentModel from './comment.ts';

export default class Commentable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('comment', {
    async: false,
    inverse: 'commentable',
    as: 'commentable',
  })
  declare comments: CommentModel[];
}
